import { Employee, buildEmployeeFromDetail } from "./Employee"
import { Landplot, buildLandPlot } from "./Landplot"
import { Location } from "./Location"
import { TaxInformationModel, buildTaxInformation } from "./TaxInformationModel"

export class QualityLevel {
    cardinality: number
    name: string
    price_per_kg: number

    constructor(q: any) {
        this.cardinality = q.cardinality
        this.name = q.grading_name
        this.price_per_kg = q.grading

    }

    static build(q: any): QualityLevel {
        return new QualityLevel(q)
    }
}

export class Organisation {
    id: number
    organisation_type: string
    positionepsg4326?: any
    /** GeoJSON point, as served by the profile query. */
    position?: any
    reputation_level: string
    location?: Location
    name: string
    taxInformations?: TaxInformationModel
    employees?: Employee[]
    isUnileverMill: boolean
    landplots?: Landplot[]
    affiliate_reward_program?: string
    niaga_at_mill_enabled?: boolean
    qualityLevels: QualityLevel[]
    timezone: string

    constructor(data: any) {
        this.id = data.id
        this.organisation_type = data.organisation_type
        this.positionepsg4326 = data.positionepsg4326
        this.position = data.position
        this.reputation_level = data.reputation_level
        this.location = data.location ? Location.build(data.location) : undefined
        this.name = data.name
        this.taxInformations = buildTaxInformation(data)
        this.employees = data.employees?.map((e) => buildEmployeeFromDetail(e))
        this.isUnileverMill = data.affiliate_reward_program !== undefined
        this.landplots = data.land_plots?.map(l => buildLandPlot(l))
        this.affiliate_reward_program = data.affiliate_reward_program
        this.niaga_at_mill_enabled = data.buyer?.niaga_at_mill_enabled ?? false
        this.timezone = data.timezone
        this.qualityLevels = data.grading?.map(g => {
            return QualityLevel.build(g)
        }
        ) ?? []
    }

    hasPosition(): boolean {
        return this.positionepsg4326 !== null && this.positionepsg4326 !== undefined
    }

    isMill(): boolean {
        return this.organisation_type === "mill"
    }

    isInProgram() {
        return this.affiliate_reward_program !== undefined && this.affiliate_reward_program !== null
    }

    static build(o: any): Organisation {
        return new Organisation(o)
    }
}